import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { OrdersTable } from '@/components/OrdersTable';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { LoadingIcon } from '@/components/ui+/LoadingIcon';

export const Route = createFileRoute('/a/orders/')({
  staticData: {
    breadcrumbs: [{ label: 'Orders' }],
  },
  component: Component,
});

function Component() {
  const ordersQuery = useQuery(api.orders.listRecent);
  if (ordersQuery.isPending) return <LoadingIcon />;
  if (ordersQuery.isError) return null; // Handled in parent layout

  return (
    <div className="min-h-[calc(100vh-(--spacing(16)))] flex-1 flex-col gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Orders</CardTitle>
        </CardHeader>
        <CardContent>
          <OrdersTable orders={ordersQuery.data} showRestaurantColumn />
        </CardContent>
      </Card>
    </div>
  );
}
